module.exports = __webpack_public_path__ + "img/Mb_Exhibition_Logo.96b60384.jpg";